/** @file Observable auth-store. */
import { createStore } from "./state.js";
import { initAuthPersistence, subscribeAuth } from "../persistence/auth.js";

/** @typedef {{ uid: string, email: string|null, displayName: string|null, photoURL: string|null } | null} AuthUser */
/** @typedef {{ status: "initializing" | "signedIn" | "signedOut", user: AuthUser }} AuthState */

/** @type {import("./state.js").Store<AuthState>} */
export const authStore = createStore(
  /** @type {AuthState} */ ({ status: "initializing", user: null }),
);

/**
 * @param {import("firebase/auth").User | null} u
 * @returns {AuthUser}
 */
function serializeUser(u) {
  if (!u) {
    return null;
  }
  return {
    uid: u.uid,
    email: u.email,
    displayName: u.displayName,
    photoURL: u.photoURL,
  };
}

/** @type {(() => void) | null} */
let unsub = null;

/**
 * Initialize auth persistence and subscribe to state.
 * Resolves after the first auth state event (so bootstrap does not flash "signedOut").
 * @returns {Promise<void>}
 */
export async function bootAuth() {
  await initAuthPersistence();
  await /** @type {Promise<void>} */ (
    new Promise((resolve) => {
    let resolved = false;
    unsub?.();
    unsub = subscribeAuth((user) => {
      authStore.set({
        status: user ? "signedIn" : "signedOut",
        user: serializeUser(user),
      });
      if (!resolved) {
        resolved = true;
        resolve();
      }
    });
    })
  );
}

/** For tests only. */
export function __unsub() {
  unsub?.();
  unsub = null;
}
